export const LINE_ENDINGS = {
  POSIX: "\n",
  WIN32: "\r\n",
};
